import { REPORTJOBS, FETCH, SETTIMEZONEDATA } from './actionType'

// initialState shows what we are going to change
const initialState = {
  // empty text field
  // empty data field
  data: null,
  // API call
  fetching: false,
  timezoneData: localStorage.getItem('timezoneData'),
}

// Checks the type of the action and returns the appropriate state
export default function reportJobsReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH:
      // Boolean describing if the data is being gathered
      return Object.assign({}, state, {
        fetching: action.fetching,
      })
    case REPORTJOBS:
      return Object.assign({}, state, {
        data: action.data,
      })
    case SETTIMEZONEDATA:
      localStorage.setItem('timezoneData', action.timezoneData)
      return Object.assign({}, state, {
        timezoneData: action.timezoneData,
      })
    default:
      // returns state as is without changes
      return state
  }
}
